import useAxiosPrivate from '../hooks/useAxiosPrivate';
import { useState } from 'react';

export default function CheckboxUsers({ user, setUsers }) {

const id = user._id;



//URLS
const HANDLESELECT_URL = 'users/handleselect';
const USERS_URL = `/users/`;


//Axios
const axiosPrivate = useAxiosPrivate()

//State
const [selected, setSelected] = useState(true)

  const handleSelect = async () => {
    setSelected(old => !old)
    const body = {id, selected}
    try {
      await axiosPrivate.put(
        HANDLESELECT_URL, body 
      )
      axiosPrivate.get(USERS_URL).then

      (function (res) {
        setUsers([...res.data]);

      });
    } catch (err) {
      console.error(err)
    }
  }



  return (
    <input
    title="Select to delete"
      type='checkbox'
      value={selected}
      // onClick={() => { step.step_is_selected === false ? select() : unselect() }}
      onClick={() => {handleSelect() }}
    ></input>
  )
}